var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 21 19",
        fill: "currentColor",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M18.6777 4H14.6777V2C14.6777 0.89 13.7877 0 12.6777 0H8.67773C7.56773 0 6.67773 0.89 6.67773 2V4H2.67773C1.56773 4 0.687734 4.89 0.687734 6L0.677734 17C0.677734 18.11 1.56773 19 2.67773 19H18.6777C19.7877 19 20.6777 18.11 20.6777 17V6C20.6777 4.89 19.7877 4 18.6777 4ZM12.6777 4H8.67773V2H12.6777V4Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }